import { REACT_APP_FEATURE_FLAG_REQUEST_INNOVATION, REACT_APP_FEATURE_FLAG_SHOW_TRAINING } from './environment'

const isFeatureEnabled = flag => flag === true || flag === 'true'

export const features = {
  'request.innovation': isFeatureEnabled(REACT_APP_FEATURE_FLAG_REQUEST_INNOVATION),
  'show.training': isFeatureEnabled(REACT_APP_FEATURE_FLAG_SHOW_TRAINING)
}
